<div fxLayout="column" fxLayoutGap="24">
    <div>
        <p-password
            [(ngModel)]="password"
            name="password"
            class="w-100-p h-44"
            [feedback]="showFeedback"
            [toggleMask]="showToggleMask"
            [placeholder]="(passwordPlaceholder | translate) + ' *'"
            (ngModelChange)="checkPassword($event)"
            [required]="true"
            [ngModelOptions]="{ standalone: true }"
            [mediumRegex]="mediumRegexPattern"
            [strongRegex]="strongRegexPattern"
        >
            <ng-template pTemplate="header">
                <span>{{ passwordPlaceholder | translate }}</span>
            </ng-template>

            <ng-template pTemplate="footer">
                <p-divider />
                <p class="mt-2">{{ "PASSWORD_CRITERIA.SUGGESTION" | translate }}</p>
                <div class="password-strength-feedback">
                    <ul>
                        <li
                            [ngClass]="{
                                'valid-feedback': passwordStrengthCheck.hasUpperCase,
                                'invalid-feedback': !passwordStrengthCheck.hasUpperCase
                            }"
                        >
                            {{ "PASSWORD_CRITERIA.UPPERCASE" | translate }}
                        </li>
                        <li
                            [ngClass]="{
                                'valid-feedback': passwordStrengthCheck.hasLowerCase,
                                'invalid-feedback': !passwordStrengthCheck.hasLowerCase
                            }"
                        >
                            {{ "PASSWORD_CRITERIA.LOWERCASE" | translate }}
                        </li>
                        <li
                            [ngClass]="{
                                'valid-feedback': passwordStrengthCheck.hasNumber,
                                'invalid-feedback': !passwordStrengthCheck.hasNumber
                            }"
                        >
                            {{ "PASSWORD_CRITERIA.NUMBER" | translate }}
                        </li>
                        <li
                            [ngClass]="{
                                'valid-feedback': passwordStrengthCheck.hasSpecialChar,
                                'invalid-feedback': !passwordStrengthCheck.hasSpecialChar
                            }"
                        >
                            {{ "PASSWORD_CRITERIA.SPECIAL_CHAR" | translate }}
                        </li>
                        <li
                            [ngClass]="{
                                'valid-feedback': passwordStrengthCheck.hasValidLength,
                                'invalid-feedback': !passwordStrengthCheck.hasValidLength
                            }"
                        >
                            {{ "PASSWORD_CRITERIA.LENGTH" | translate }}
                        </li>
                    </ul>
                </div>
            </ng-template>

            @if (passwordStrengthCheck.valid) {
                <div class="valid-feedback">
                    {{ "APP_PLATFORM_LOGIN.PASSWORD_VALID" | translate }}
                </div>
            }
        </p-password>
    </div>
    <div>
        <p-password
            [(ngModel)]="confirmPassword"
            class="w-100-p h-44"
            [feedback]="false"
            [toggleMask]="showToggleMask"
            [placeholder]="(confirmPasswordPlaceholder | translate) + ' *'"
            (ngModelChange)="checkConfirmPassword($event)"
            [required]="true"
            [ngModelOptions]="{ standalone: true }"
            name="confirmPassword"
        >
        </p-password>

        @if (confirmPassword && passwordMismatch) {
            <div>
                <p class="login-error-message p-0 mt-0 mb-16">
                    {{ "APP_PLATFORM_LOGIN.ENTER_SAME_PASSWORD" | translate }}
                </p>
            </div>
        }
    </div>
</div>
